export const dataGoods = [
  {
    name: 'Gryffindor Logo Backpack',
    img: './Assets/Images/Goods/gryf_bag.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel'],
    price: '36',
    description:
      'Celebrate your Hogwarts house pride with this unique Gryffindor backpack. Made from 100% cotton, the backpack features a burgundy design with yellow vertical and diagonal stripes across the front. The iconic Gryffindor crest is embroidered into the centre of the backpack. The bag has black handles as well as black straps which can be adjusted for a suitable and comfortable fit. The Gryffindor backpack is complete with various compartments and pockets, perfect to keep safe or hide any magical trinkets when you are on the go.',
    id: '1',
  },
  {
    name: 'Gryffindor Quidditch Bear',
    img: './Assets/Images/Goods/gryf_bear.png',
    house: 'Gryffindor',
    categories: ['Quidditch', 'Toys', 'Souvenirs'],
    price: '36',
    description:
      'This soft, huggable Gryffindor Quidditch Bear is eager to catch the golden snitch and fly straight into your heart! The soft brown teddy bear is dressed up in a Gryffindor seeker uniform very much like Harry Potter’s own and represents house Gryffindor in a stylish crimson red. His deluxe robe comes lined in a brilliant canary yellow, fastens with a Velcro closure, and features a tiny detailed Gryffindor patch on the chest. He also wears a handsome removable red and yellow striped shirt and pair of black trousers. The official Harry Potter logo embroidery can be found on his right foot.',
    id: '2',
  },
  {
    name: 'Gryffindor Robe',
    img: './Assets/Images/Goods/gryf_coat.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Souvenirs'],
    price: '75',
    description:
      'Celebrate your Hogwarts house pride with this replica Gryffindor robe, as seen in the Harry Potter film series. The Personalised Gryffindor Robe features contrasting scarlet lining, pockets (there is even a hidden pocket for your wand!), and embroidered Gryffindor crest.',
    id: '3',
  },
  {
    name: 'Gryffindor Gift Trunk',
    img: './Assets/Images/Goods/gryf_gift_set.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Books', 'Wands', 'Sweets', 'Travel', 'Toys', 'Souvenirs'],
    price: '175',
    description:
      'Celebrate your house pride with this bespoke Gryffindor Trunk, perfect for Harry Potter fans to add to their collection. This trunk has been specially designed to resemble the trunk that students would take on their travels on the Hogwarts Express. Explore the exclusive souvenirs and unique collectables, the ultimate gift experience for every aspiring witch or wizard. Each Hogwarts Gift Trunk measures approximately 45cm x 30cm x 23cm and features a carry handle and clasp. The Hogwarts school crest is printed on the top of the trunk and features custom initials on the side. Trunk materials consist of 60% plywood, 20% PU, 10% metal, and 10% glues/lacquers. This decorative collectable is not designed for travel use, or to carry overly heavy items. Please note this trunk is not a toy.',
    id: '4',
  },
  {
    name: 'The Sword of Gryffindor Wand',
    img: './Assets/Images/Goods/gryf_wand.png',
    house: 'Gryffindor',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'This wand is inspired by elements of house-founder, Godric Gryffindor’s sword, known to be “the best duelist of his time”. It is a sublime choice for Gryffindor students seeking a connection with their house history and ancestry, and for those who possess the traits of courage and bravery, like Godric Gryffindor. The wand is presented in a high-quality box, complete with vellum paper overlay and an information card. Part of the Exclusive Design Collection Series, The Sword of Gryffindor wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '5',
  },
  {
    name: 'Personalised Gryffindor Triwizard Shirt',
    img: './Assets/Images/Goods/gryf_shirt_quid.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Show your loyalty and celebrate your house pride with this bespoke Gryffindor Triwizard Shirt. The long-sleeved shirt comes in the traditional house colour burgundy which is combined with black stripes. The iconic Hogwarts crest is embroidered onto the left-hand side of the shirt which is made up of the symbolic Hogwarts house animals; a lion for Gryffindor, a serpent for Slytherin, a badger for Hufflepuff and an eagle for Ravenclaw.',
    id: '6',
  },
  {
    name: 'Personalised Gryffindor House Seeker T-Shirt',
    img: './Assets/Images/Goods/gryf_quid_shirt.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Celebrate your house pride with this athletic Harry Potter Seeker Jersey. The t-shirt has been designed with scarlet red and yellow colouring, representing the traditional colours of the Gryffindor house. The t-shirt is complete with the number `07` printed on the front in gold applique, and the name `Potter` on the reverse.',
    id: '7',
  },
  {
    name: 'Gryffindor Mini Gift Trunk',
    img: './Assets/Images/Goods/gryf_set.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '75',
    description:
      'This bespoke Gryffindor Mini Gift Trunk celebrates what it means to be a Gryffindor with a selection of exclusive souvenirs and unique collectables! Specially designed to resemble what students would take on their travels on the Hogwarts Express, this trunk is the ultimate gifting experience for those sorted into the Gryffindor house, or for all Harry Potter fans!',
    id: '8',
  },
  {
    name: 'The Gryffindor Mascot Wand',
    img: './Assets/Images/Goods/gryf_wand_1.png',
    house: 'Gryffindor',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'Inspired by the bold and mighty animal of Gryffindor House, the Gryffindor Mascot Wand celebrates leonine courage and daring in the face of conflict. Perfect for all proud Gryffindors, this design is for those who valiantly roar into the unknown. The wand is presented in a high-quality box, complete with vellum paper overlay and an information card. Part of the Exclusive Design Collection Series, this unique Gryffindor Mascot wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '9',
  },
  {
    name: 'Gryffindor Hooded Sweatshirt',
    img: './Assets/Images/Goods/gryf_hoodie.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel'],
    price: '40',
    description:
      'Add some magic to your wardrobe with this unisex Gryffindor hooded sweatshirt. The scarlet red hoodie features a yellow lion, the traditional symbol of the Gryffindor house, and is complete with the lion icon and crown printed in the lining of the hood. The house name is screen-printed along the sleeve in yellow. The hoodie also includes a full tunnel pocket in front, a yellow zip and two yellow strings which can be adjusted for a suitable and comfortable fit.',
    id: '10',
  },
  {
    name: 'Gryffindor Fleece Hoodie',
    img: './Assets/Images/Goods/gryf_hoodie_1.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel'],
    price: '50',
    description:
      'Refresh your wardrobe with this unisex Gryffindor fleece hoodie. The scarlet red hoodie features a yellow lion embroidered into the right-hand side of the chest. The hoodie is complete with the Gryffindor house motto ‘Courage’, ‘Bravery’ and ‘Determination’ printed in yellow.',
    id: '11',
  },
  {
    name: 'Gryffindor Quidditch Jumper',
    img: './Assets/Images/Goods/gryf_quid.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch'],
    price: '45',
    description:
      'Cheer on your favourite Hogwarts house Quidditch team with this Gryffindor Quidditch jumper. Featuring an embroidered Gryffindor house crest patch on the left chest and in the scarlet and gold colours of the house, this Quidditch sweater is a faithful celebration of the ones seen in the Harry Potter film series.',
    id: '12',
  },
  {
    name: 'Gryffindor Quidditch Knitted Adult Jumper',
    img: './Assets/Images/Goods/gryf_quid_short.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch'],
    price: '75',
    description:
      'Win your next Quidditch match and with his unique Gryffindor Quidditch Adult Jumper. The knitted jumper is made from 100% Scottish-spun lambswool and has been designed in the Scottish Mill that made the costumes for the cast and extras in the Harry Potter film series.',
    id: '13',
  },
  {
    name: 'Gryffindor Knitted Crest Scarf',
    img: './Assets/Images/Goods/gryf_scarf.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '18',
    description:
      'Keep warm and complete your Gryffindor look with this unique knitted scarf. The scarf comes in deep red and yellow, the traditional colours of the Gryffindor house. The Gryffindor house crest is embroidered on the left-hand side of the scarf which features a lion, the iconic animal of the house.',
    id: '14',
  },
  {
    name: 'Gryffindor Sock Set (3 Pack)',
    img: './Assets/Images/Goods/gryf_socks.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Souvenirs', 'Travel'],
    price: '12',
    description:
      'Treat your feet with these super soft and comfy Gryffindor socks. The socks are available in 3 themed socks with various Gryffindor designs in traditional house colours of burgundy and yellow.',
    id: '15',
  },
  {
    name: 'Gryffindor T-Shirt',
    img: './Assets/Images/Goods/gryf_shirt.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel'],
    price: '19',
    description:
      'Possibly the most famous House of Hogwarts School of Witchcraft and Wizardry, Gryffindor students are known to possess the traits of determination, courage, and bravery. This scarlet red t-shirt features a prominent Gryffindor House crest on the front and is the perfect addition to any proud Gryffindor’s wardrobe!',
    id: '16',
  },
  {
    name: 'Gryffindor Milk Chocolate Bar',
    img: './Assets/Images/Goods/gryf_choco.png',
    house: 'Gryffindor',
    categories: ['Sweets', 'Souvenirs'],
    price: '5',
    description:
      'Get a taste of the Wizarding World with this delicious Gryffindor Milk Chocolate Bar. This scrumptious snack is made with fudge flavoured milk chocolate and is the perfect sweet treat to make your mouth water.',
    id: '17',
  },
  {
    name: 'Gryffindor Knitted Mitten Capped Gloves',
    img: './Assets/Images/Goods/gryf_gloves.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '12',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with these Gryffindor Knitted Mitten Capped Gloves. The Gryffindor gloves come in burgundy and have yellow stripes across the centre, the traditional house colours of Gryffindor.',
    id: '18',
  },
  {
    name: 'Gryffindor Bobble Hat',
    img: './Assets/Images/Goods/gryf_hat.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '17',
    description:
      'Show off your house pride and keep warm with this Gryffindor bobble hat. The hat comes in a deep red, the traditional colour of Gryffindor house and features two white stripes.',
    id: '19',
  },
  {
    name: 'Faux Leather Gryffindor Crest Notebook',
    img: './Assets/Images/Goods/gryf_book.png',
    house: 'Gryffindor',
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'Any proud Gryffindor would be pleased to have this vintage look faux-leather notebook in their home study! This burgundy red journal features an impressive metal Gryffindor house crest on the front cover, and gold foiled detailing near the border’s edge.',
    id: '20',
  },
  {
    name: 'Gryffindor Moulded Mug',
    img: './Assets/Images/Goods/gryf_cup.png',
    house: 'Gryffindor',
    categories: ['Travel', 'Souvenirs'],
    price: '12',
    description:
      'Pour yourself a mugful of your favourite drink in this Gryffindor mug. The mug is made from ceramic and features a house robe, with a scarlet red hood on the reverse, and house tie in red and yellow, the traditional colours of the Gryffindor house.',
    id: '21',
  },
  {
    name: 'Gryffindor Crest Pin',
    img: './Assets/Images/Goods/gryf_pin.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '8',
    description:
      'Celebrate house pride and add this bespoke Gryffindor pin to your Harry Potter collectibles. The pin depicts a lion, the iconic symbol of the Gryffindor house, overlaid on a red glitter background.',
    id: '22',
  },
  {
    name: 'First Edition Gryffindor Enamel Pin Set',
    img: './Assets/Images/Goods/gryf_pins.png',
    house: 'Gryffindor',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '50',
    description:
      'Start your Harry Potter Fan Club Pin Seeking collection with this Gryffindor house pin set. This 6-pin set includes the Gryffindor house crest, Fat Lady portrait, Gryffindor house banner, Sword of Gryffindor, Gryffindor scarf, and an exclusive pin available only when you purchase this set - the Gryffindor lion! Each pin is finely detailed and is themed around the house colours, making it the perfect gift for all Gryffindor fans.',
    id: '23',
  },
  {
    name: 'Hufflepuff Logo Backpack',
    img: './Assets/Images/Goods/huff_bag.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel'],
    price: '36',
    description:
      'Celebrate your Hogwarts house pride with this unique Hufflepuff backpack. Made from 100% cotton, the backpack features a black design with yellow vertical and diagonal stripes across the front. The iconic Hufflepuff crest is embroidered into the centre of the backpack. The bag has black handles as well as black straps which can be adjusted for a suitable and comfortable fit. The Hufflepuff backpack is complete with various compartments and pockets, perfect to keep safe or hide any magical trinkets when you’re on-the-go.',
    id: '24',
  },
  {
    name: 'Hufflepuff Robe',
    img: './Assets/Images/Goods/huff_coat.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Souvenirs'],
    price: '75',
    description:
      'Celebrate your Hogwarts house pride with this replica Personalised Hufflepuff robe, as seen in the Harry Potter film series. The Hufflepuff robe features contrasting yellow lining, pockets (there’s even a hidden pocket for your wand!), and embroidered Hufflepuff crest.',
    id: '25',
  },
  {
    name: 'Hufflepuff Gift Trunk',
    img: './Assets/Images/Goods/huff_gift_set.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Books', 'Wands', 'Sweets', 'Travel', 'Toys', 'Souvenirs'],
    price: '175',
    description:
      'Celebrate your house pride with this bespoke Hufflepuff Trunk, perfect for Harry Potter fans to add to their collection. This trunk has been specially designed to resemble the trunk that students would take on their travels on the Hogwarts Express. Explore the exclusive souvenirs and unique collectables, the ultimate gift experience for every aspiring witch or wizard. Each Hogwarts Gift Trunk measures approximately 45cm x 30cm x 23cm and features a carry handle and clasp. The Hogwarts school crest is printed on the top of the trunk and features custom initials on the side. Trunk materials consist of 60% plywood, 20% PU, 10% metal, and 10% glues/lacquers. This decorative collectable is not designed for travel use, or to carry overly heavy items. Please note this trunk is not a toy.',
    id: '26',
  },
  {
    name: 'The Cup of Hufflepuff Wand',
    img: './Assets/Images/Goods/huff_wand_1.png',
    house: 'Hufflepuff',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'A design is inspired by elements of Helga Hufflepuff’s cup, with a gold fluted handle and topped by a relief sculpture of a badger, the House mascot. This wand is for Hufflepuff students who cherish the history of their house-founder and always seeks to emulate her kind and fair demeanour. The wand is presented in a high-quality box, complete with vellum paper overlay and information card. Part of the Exclusive Design Collection Series, The Cup of Hufflepuff wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '27',
  },
  {
    name: 'Personalised Hufflepuff Triwizard Shirt',
    img: './Assets/Images/Goods/huff_shirt_quid.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Show your loyalty and celebrate your house pride with this bespoke Hufflepuff Triwizard Shirt. The long-sleeved shirt comes in the traditional house colour of yellow which is combined with black stripes. The iconic Hogwarts crest is embroidered onto the left-hand side of the shirt which is made up of the symbolic Hogwarts house animals; a lion for Gryffindor, a serpent for Slytherin, a badger for Hufflepuff and an eagle for Ravenclaw.',
    id: '28',
  },
  {
    name: 'Personalised Hufflepuff House Seeker T-Shirt',
    img: './Assets/Images/Goods/huff_quid_shirt.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Celebrate your Hogwarts house loyalty with this bespoke Hufflepuff House Seeker T-Shirt. The short-sleeved t-shirt comes in the traditional house colour yellow which is combined with black stripes along each sleeve. The number 07 is printed in a black and white design in the centre of the t-shirt alongside the word Hufflepuff which is printed across the chest in black. This personalised Hufflepuff t-shirt is complete with an embroidered black badger, the iconic Hufflepuff house animal.',
    id: '29',
  },
  {
    name: 'Hufflepuff Knitted Hat',
    img: './Assets/Images/Goods/huff_hat_1.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '14',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with this Hufflepuff Knitted Hat. The hat features the traditional Hufflepuff colours of bright yellow and black and has been designed with the Hufflepuff house crest embroidered into the centre of the hat which showcases a badger, the iconic animal of Hufflepuff.',
    id: '30',
  },
  {
    name: 'The Hufflepuff Mascot Wand',
    img: './Assets/Images/Goods/huff_wand.png',
    house: 'Hufflepuff',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'Inspired by the humble and industrious badger, the animal of Hufflepuff, this unique Hufflepuff wand celebrates the iconic, often underestimated animal. Embodying Hufflepuff values, this delicately designed wand is for those who treasure hard-work and loyalty. The bespoke wand is presented in a high-quality box and is complete with vellum paper overlay and information card. Part of the Exclusive Design Collection Series, this unique Hufflepuff Mascot wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '31',
  },
  {
    name: 'Hufflepuff Hooded Sweatshirt',
    img: './Assets/Images/Goods/huff_hoodie_1.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel'],
    price: '40',
    description:
      'Add some Wizarding World magic to your wardrobe with this unisex Hufflepuff sweatshirt. The grey hoodie features a black and yellow badger, the traditional symbol of the Hufflepuff house, and is complete with the badger icon printed in the lining of the hood.',
    id: '32',
  },
  {
    name: 'Hufflepuff Fleece Hoodie',
    img: './Assets/Images/Goods/huff_hoodie.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel'],
    price: '50',
    description:
      'Refresh your wardrobe with this unisex Hufflepuff fleece hoodie. The black hoodie features a yellow badger embroidered into the right-hand side of the chest. The hoodie is complete with the Hufflepuff house motto ‘Patience’, ‘Dedication’ and Loyalty’ printed in yellow.',
    id: '33',
  },
  {
    name: 'Hufflepuff Quidditch Jumper',
    img: './Assets/Images/Goods/huff_quid.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch'],
    price: '45',
    description:
      'Cheer on your favourite Hogwarts house Quidditch team with this Hufflepuff Quidditch jumper. Featuring an embroidered Hufflepuff house crest patch on the left chest, and in the yellow and black colours of the house, this Quidditch sweater is a faithful celebration of the ones seen in the Harry Potter film series.',
    id: '34',
  },
  {
    name: 'Hufflepuff Quidditch Knitted Adult Jumper',
    img: './Assets/Images/Goods/huff_quid_short.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch'],
    price: '75',
    description:
      'Represent your House team in comfort with this Hufflepuff Quidditch sweater. Perfect for the Quidditch pitch, at muggle school, or in the stands!',
    id: '35',
  },
  {
    name: 'Hufflepuff Knitted Crest Scarf',
    img: './Assets/Images/Goods/huff_scarf.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '18',
    description:
      'Keep warm and complete your Hufflepuff look with this unique knitted scarf. The scarf comes in mustard yellow and black, the traditional colours of the Hufflepuff house. The Hufflepuff house crest is embroidered on the left end of the scarf which features an badger, the iconic animal of the house.',
    id: '36',
  },
  {
    name: 'Hufflepuff Sock Set (3 Pack)',
    img: './Assets/Images/Goods/huff_socks.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Souvenirs', 'Travel'],
    price: '12',
    description:
      'Treat your feet with these super soft and comfy Hufflepuff socks. The socks are available in 3 themed socks with various Hufflepuff designs in traditional house colours of yellow and black.',
    id: '37',
  },
  {
    name: 'Hufflepuff T-Shirt',
    img: './Assets/Images/Goods/huff_shirt.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel'],
    price: '19',
    description:
      'Rumoured to be J.K. Rowling’s favourite House of Hogwarts School of Witchcraft and Wizardry, Hufflepuff students are known to possess the traits of dedication, patience and loyalty. This black t-shirt features a prominent yellow Hufflepuff House crest on the front and is the perfect addition to any proud Hufflepuffs wardrobe! ',
    id: '38',
  },
  {
    name: 'Hufflepuff Milk Chocolate Bar',
    img: './Assets/Images/Goods/huff_choco.png',
    house: 'Hufflepuff',
    categories: ['Sweets', 'Souvenirs'],
    price: '5',
    description:
      'Get a taste of the Wizarding World with this delicious Hufflepuff Milk Chocolate Bar. This scrumptious snack is made up of hidden popping candy pieces coated with milk chocolate, making it the perfect sweet treat to make your mouth water.',
    id: '39',
  },
  {
    name: 'Hufflepuff Bobble Hat',
    img: './Assets/Images/Goods/huff_hat.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '17',
    description:
      'This cap is perfect for any Hufflepuff; the faded yellow logo against the grey will ensure that you stand out from the crowd as a Hufflepuff Quidditch Team Captain.',
    id: '40',
  },
  {
    name: 'Faux Leather Hufflepuff Crest Notebook',
    img: './Assets/Images/Goods/huff_book.png',
    house: 'Hufflepuff',
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'Any proud Hufflepuff would be pleased to have this vintage look faux-leather notebook in their home study! This deep yellow journal features an impressive metal Hufflepuff house crest on the front cover, and gold foiled detailing near the border’s edge.Inside you can find a Hufflepuff Quidditch design printed on the lining of the cover, and distressed parchment style pages edged in gold foil.  A Hufflepuff badger can be seen on each page at the bottom right-hand corner. Includes a ribbon in house scarf colours to mark your place.Add this handsome Hufflepuff notebook to your collection today! Also available in the three other Hogwarts houses, and a Hogwarts school design.',
    id: '41',
  },
  {
    name: 'Hufflepuff Moulded Mug',
    img: './Assets/Images/Goods/huff_cup.png',
    house: 'Hufflepuff',
    categories: ['Travel', 'Souvenirs'],
    price: '12',
    description:
      'Pour yourself a mugful of your favourite drink in this Hufflepuff Moulded Mug. The mug is made from ceramic and features a house robe, with a bright yellow hood on the reverse, and house tie in yellow and black, the traditional colours of the Hufflepuff house.',
    id: '42',
  },
  {
    name: 'Hufflepuff Cup Enamel Pin',
    img: './Assets/Images/Goods/huff_pin.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '9',
    description:
      'Add some Hogwarts history to your Harry Potter Fan Club Pin Seeking collection with this Hufflepuff Cup pin! This pin features a finely detailed, enameled image of the Hufflepuff Cup above the wording ’Patience, Dedication, Loyalty’ displayed atop a black banner.This yellow and black enamel pin is part of the Harry Potter Fan Club Pin Seeking collection. It comes with a Hufflepuff-inspired backing card.',
    id: '43',
  },
  {
    name: 'Hufflepuff Mascot Badger Soft Toy',
    img: './Assets/Images/Goods/huff_pet.png',
    house: 'Hufflepuff',
    categories: ['Toys', 'Quidditch', 'Souvenirs'],
    price: '27',
    description:
      'This realistic Hufflepuff badger will make a stunning addition to every aspiring Hogwarts student’s soft toy collection! The loyal mascot features soft brushed features, expressive acrylic brown eyes and detailed fur markings. A knit gold and black striped house scarf completes the look, finished with a small embroidered Hufflepuff badge crest. The badger stands approximately 4 3/4’ in height and 12’ in length, and will make a wonderful gift for any soft animal collector or those sorted into Hufflepuff house. This Hufflepuff Mascot Badger Soft Toy is made of polyester, and surface washable. Best suited for ages 18 months and over.',
    id: '44',
  },
  {
    name: 'Hufflepuff Athletic Jacket',
    img: './Assets/Images/Goods/huff_jacket.png',
    house: 'Hufflepuff',
    categories: ['Clothes', 'Travel'],
    price: '24',
    description:
      'After taking the United States by storm Spirit Jersey® have arrived in the United Kingdom.  Showing your pride for your favourite Hogwarts house has never been so fun… or so bold. ',
    id: '45',
  },
  {
    name: 'Ravenclaw Robe',
    img: './Assets/Images/Goods/raven_coat.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Souvenirs'],
    price: '75',
    description:
      'Celebrate your Hogwarts house pride with this replica Personalised Ravenclaw robe, as seen in the Harry Potter film series. The Ravenclaw robe features contrasting blue lining, pockets (there’s even a hidden pocket for your wand!), and embroidered Ravenclaw crest.',
    id: '46',
  },
  {
    name: 'Ravenclaw Gift Trunk',
    img: './Assets/Images/Goods/raven_gift_set.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Books', 'Wands', 'Sweets', 'Travel', 'Toys', 'Souvenirs'],
    price: '175',
    description:
      'This bespoke Ravenclaw Pride Gift Trunk celebrates what it means to be a Ravenclaw with a selection of exclusive souvenirs and unique collectables! Specially designed to resemble what students would take on their travels on the Hogwarts Express, this trunk is the ultimate gifting experience for those sorted into the Ravenclaw house, or for all Harry Potter fans! Each Hogwarts Gift Trunk measures approximately 45cm x 30cm x 23cm and features a carry handle and clasp. The Hogwarts school crest is printed on the top of the trunk and features custom initials on the side. Trunk materials consist of 60% plywood, 20% PU, 10% metal, and 10% glues/lacquers. This decorative collectable is not designed for travel use, or to carry overly heavy items. ',
    id: '47',
  },
  {
    name: 'The Diadem of Ravenclaw Wand',
    img: './Assets/Images/Goods/raven_wand_1.png',
    house: 'Ravenclaw',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'Inspired by the powerful and famed Diadem of the Ravenclaw House is this bespoke Diadem of Ravenclaw Wand. This ornate wand features decorative detailing of the lost Diadem including pristine sapphire-like stones, and unique metalwork on its handle. Created with the Ravenclaw house in mind, this unique wand is designed for a Ravenclaw who finds guidance in her wise words. The wand measures approximately 18 inches long and is complete with a deluxe collector’s box.',
    id: '48',
  },
  {
    name: 'Personalised Ravenclaw Triwizard Shirt',
    img: './Assets/Images/Goods/raven_shirt_quid.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Show your loyalty and celebrate your house pride with this bespoke Ravenclaw Triwizard Shirt. The long-sleeved shirt comes in the traditional house colour of navy blue which is combined with black stripes. The iconic Hogwarts crest is embroidered onto the left-hand side of the shirt which is made up of the symbolic Hogwarts house animals; a lion for Gryffindor, a serpent for Slytherin, a badger for Hufflepuff and an eagle for Ravenclaw.',
    id: '49',
  },
  {
    name: 'Personalised Ravenclaw House Seeker T-Shirt',
    img: './Assets/Images/Goods/raven_quid_shirt.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Celebrate your Hogwarts house loyalty with this bespoke Ravenclaw House Seeker T-Shirt. The short-sleeved t-shirt comes in the traditional house colour blue which is combined with grey stripes along each sleeve. The number 07 is printed in a grey and white design in the centre of the t-shirt alongside the word Ravenclaw which is printed across the chest in grey. This personalised Ravenclaw t-shirt is complete with an embroidered grey and white eagle, the iconic Ravenclaw house animal.',
    id: '50',
  },
  {
    name: 'Ravenclaw Knitted Hat',
    img: './Assets/Images/Goods/raven_hat_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '14',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with this Ravenclaw Knitted Hat. The hat features the traditional Ravenclaw colours of navy blue and grey and has been designed with the Ravenclaw house crest embroidered into the centre of the hat which showcases an eagle, the iconic animal of Ravenclaw.',
    id: '51',
  },
  {
    name: 'Ravenclaw Mini Gift Trunk',
    img: './Assets/Images/Goods/raven_set.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '75',
    description:
      'Take home this mini version of the Hogwarts School Trunk, crafted to resemble those used by Hogwarts students travelling on the Hogwarts Express. This bespoke Ravenclaw gift trunk features some exclusive items from our knitwear collection, as well as a Hogwarts Acceptance Letter, personalised with your own name and complete with an exclusive supplies list.',
    id: '52',
  },
  {
    name: 'The Ravenclaw Mascot Wand',
    img: './Assets/Images/Goods/raven_wand.png',
    house: 'Ravenclaw',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'Inspired by the House of Rowena Ravenclaw, the Ravenclaw Mascot Wand evokes the animal’s likeness, with its wings forming the top of the handle. Symbolic of one of the most intelligent animals in existence, this wand is designed for those with a love of learning. The wand is presented in a high-quality box, complete with vellum paper overlay and an information card. Part of the Exclusive Design Collection Series, this unique Ravenclaw Mascot wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '53',
  },
  {
    name: 'Ravenclaw Hooded Sweatshirt',
    img: './Assets/Images/Goods/raven_hoodie.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '40',
    description:
      'Add a dash of magic to your wardrobe with this unisex Ravenclaw sweatshirt. The blue hoodie features a black design of a raven, the traditional symbol of the Ravenclaw house, and is complete with the raven icon printed in the lining of the hood.',
    id: '54',
  },
  {
    name: 'Ravenclaw Fleece Hoodie',
    img: './Assets/Images/Goods/raven_hoodie_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '50',
    description:
      'Refresh your wardrobe with this unisex Ravenclaw fleece hoodie. The navy-blue hoodie features a white eagle embroidered into the right-hand side of the chest. The hoodie is complete with the Ravenclaw house motto ‘Learning’, ‘Wit’ and ‘Wisdom’ printed in white.',
    id: '55',
  },
  {
    name: 'Ravenclaw Quidditch Jumper',
    img: './Assets/Images/Goods/raven_quid.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch'],
    price: '45',
    description:
      'Cheer on your favourite Hogwarts house Quidditch team with this Ravenclaw Quidditch jumper. Featuring an embroidered Ravenclaw house crest patch on the left chest in the blue and silver colours of the house, this Quidditch sweater is a faithful celebration of the ones seen in the Harry Potter film series. This Ravenclaw Quidditch sweater is made from 100% super soft acrylic material and is machine washable.',
    id: '56',
  },
  {
    name: 'Ravenclaw Logo Backpack',
    img: './Assets/Images/Goods/raven_bag.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '36',
    description:
      'Celebrate your Hogwarts house pride with this unique Ravenclaw backpack. Made from 100% cotton, the backpack features a navy-blue design with grey vertical and diagonal stripes across the front. The iconic Ravenclaw crest is embroidered into the centre of the backpack. The bag has black handles as well as black straps which can be adjusted for a suitable and comfortable fit. The Ravenclaw backpack is complete with various compartments and pockets, perfect to keep safe or hide any magical trinkets when you’re on-the-go.',
    id: '57',
  },
  {
    name: 'Ravenclaw Knitted Crest Scarf',
    img: './Assets/Images/Goods/raven_scarf.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '18',
    description:
      'Keep warm and complete your Ravenclaw look with this unique knitted scarf. The scarf comes in navy blue and grey, the traditional colours of the Ravenclaw house. The Ravenclaw house crest is embroidered on the left-hand side of the scarf which features an eagle, the iconic animal of the house.',
    id: '58',
  },
  {
    name: 'Ravenclaw Sock Set (3 Pack)',
    img: './Assets/Images/Goods/raven_socks.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Souvenirs', 'Travel'],
    price: '12',
    description:
      'Treat your feet with these super soft and comfy Ravenclaw socks. The socks are available in 3 themed socks with various Ravenclaw designs in traditional house colours of navy blue and grey.',
    id: '59',
  },
  {
    name: 'Ravenclaw T-Shirt',
    img: './Assets/Images/Goods/raven_shirt_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '19',
    description:
      'A dark blue t-shirt featuring a classic style Ravenclaw house crest on the front. There will be no mistaking what house you represent while wearing this this comfy crew neck.',
    id: '60',
  },
  {
    name: 'Ravenclaw Milk Chocolate Bar',
    img: './Assets/Images/Goods/raven_choco.png',
    house: 'Ravenclaw',
    categories: ['Sweets', 'Souvenirs'],
    price: '5',
    description:
      'Get a taste of the Wizarding World with this delicious Ravenclaw Milk Chocolate Bar. This scrumptious snack is made up of toffee chunks coated with milk chocolate, making it the perfect sweet treat to make your mouth water.',
    id: '61',
  },
  {
    name: 'Ravenclaw Lined Backpack',
    img: './Assets/Images/Goods/raven_bag_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '32',
    description:
      'Add this unique Ravenclaw backpack to your wardrobe. The bag has been designed in the traditional house colour of blue and features the iconic Ravenclaw crest embroidered in yellow, black and blue. It features the word ‘Ravenclaw’ on the embroidered crest, with a silver zip and has a house checkerboard pattern on the inside lining of the backpack. The bag has additional features including a zipper pocket, handle, and adjustable padded straps for suitable and comfortable wear for everyday use. Measures 43x40 cm.',
    id: '62',
  },
  {
    name: 'Ravenclaw Bobble Hat',
    img: './Assets/Images/Goods/raven_hat.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '17',
    description:
      'This striped Ravenclaw bobble hat will have you warm and comfy in the cooler weather. Offered in the traditional navy dark blues and silvered tones of Ravenclaw, there will be no doubt which Hogwarts house is your favourite!',
    id: '63',
  },
  {
    name: 'Faux Leather Ravenclaw Crest Notebook',
    img: './Assets/Images/Goods/raven_book.png',
    house: 'Ravenclaw',
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'Any proud Ravenclaw would be pleased to have this vintage look faux-leather notebook in their home study! This deep blue journal features an impressive metal Ravenclaw house crest on the front cover, and silver foiled detailing near the border’s edge. Inside you can find a Ravenclaw Quidditch print on the lining of the cover, and distressed parchment style pages that are edged in silver foil.  A Ravenclaw eagle can be seen on each page at the bottom right-hand corner. Includes a ribbon in house scarf colours to mark your place.',
    id: '64',
  },
  {
    name: 'Ravenclaw Diadem Enamel Pin',
    img: './Assets/Images/Goods/raven_pin.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '9',
    description:
      'Add some Ravenclaw flair to your Harry Potter Fan Club Pin Seeking collection with this Ravenclaw’s Diadem pin. This pin features a finely detailed image of the Ravenclaw diadem above the wording ’Wit, Learning, Wisdom’ in a blue banner.',
    id: '65',
  },
  {
    name: 'Ravenclaw Crest Pin',
    img: './Assets/Images/Goods/raven_pin_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '9',
    description:
      'Celebrate house pride and add this bespoke Ravenclaw pin to your Harry Potter collectibles. The pin depicts an eagle, the iconic symbol of the Ravenclaw house, overlayed on a blue glitter background.',
    id: '66',
  },
  {
    name: 'Ravenclaw Quidditch Team Captain T-Shirt',
    img: './Assets/Images/Goods/raven_shirt.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Travel'],
    price: '23',
    description:
      'Join the Ravenclaw Quidditch team with this Kids Ravenclaw Quidditch Team Captain t-shirt. The t-shirt is a blue colour, the traditional colour of the Ravenclaw house, and features a raised flock print design across the chest in grey of the Ravenclaw house animal, an eagle.',
    id: '67',
  },
  {
    name: 'Ravenclaw Reversible Knit Scarf',
    img: './Assets/Images/Goods/raven_scarf_1.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '24',
    description:
      'Purchase your very own piece of Harry Potter movie memorabilia and bring the magic of Hogwarts home with you with this Ravenclaw scarf. Made by Lochaven of Scotland who supplied the original cast with their school outfits, this navy and silver Ravenclaw scarf is a faithful reproduction of the ones worn within the film series.',
    id: '68',
  },
  {
    name: 'Ravenclaw Knitted Mitten Capped Gloves',
    img: './Assets/Images/Goods/raven_gloves.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '12',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with these Ravenclaw Knitted Mitten Capped Gloves. The gloves come in a navy-blue design and have grey stripes across the centre, the traditional house colours of Ravenclaw.',
    id: '69',
  },
  {
    name: 'Ravenclaw Logo Sweatshirt',
    img: './Assets/Images/Goods/raven_shirt_2.png',
    house: 'Ravenclaw',
    categories: ['Clothes', 'Travel'],
    price: '24',
    description:
      'What does it take to be sorted into Ravenclaw house? This sleek graphic t-shirt can help answer that question! This Ravenclaw Attribute T-Shirt is covered in various Ravenclaw symbolism, proudly displaying the three most prominent traits associated with the house: Wisdom Learning and Wit in bold, distressed fonts. A large screen print design of Ravenclaw’s iconic house mascot is featured across the left chest.',
    id: '70',
  },
  {
    name: 'Slytherin Robe',
    img: './Assets/Images/Goods/slyth_coat.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Souvenirs'],
    price: '75',
    description:
      'Celebrate your Hogwarts house pride with this replica Personalised Slytherin Robe, as seen in the Harry Potter film series. The Slytherin robe features contrasting green lining, pockets (there is even a hidden pocket for your wand!), and embroidered Slytherin crest.',
    id: '71',
  },
  {
    name: 'Slytherin Gift Trunk',
    img: './Assets/Images/Goods/slyth_gift_set.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Books', 'Wands', 'Sweets', 'Travel', 'Toys', 'Souvenirs'],
    price: '175',
    description:
      'Celebrate your house pride with this bespoke Slytherin trunk, perfect for Harry Potter fans to add to their collection. This trunk has been specially designed to resemble the trunk that students would take on their travels on the Hogwarts Express. Explore the exclusive souvenirs and unique collectables, the ultimate gift experience for every aspiring witch or wizard. Each Hogwarts Gift Trunk measures at approximately 45cm x 30cm x 23cm and features a carry handle and clasp. The Hogwarts school crest is printed on the top of the trunk and features custom initials on the side. Trunk materials consist of 60% plywood, 20% PU, 10% metal, and 10% glues/lacquers. This decorative collectable is not designed for travel use, or to carry overly heavy items. Please note this trunk is not a toy.',
    id: '72',
  },
  {
    name: 'The Locket Of Slytherin Wand',
    img: './Assets/Images/Goods/slyth_wand_1.png',
    house: 'Slytherin',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'A wand inspired by the Slytherin Locket artefact, with an octagonal handle like the eight-sided locket. The wand is embellished with etched runes and includes an emerald-like stone, evocative of the locket’s decorative features. A proud Slytherin who seeks artefacts from the House’s past will not resist this wand. The wand is presented in a high-quality box, complete with vellum paper overlay and an information card. Part of the Exclusive Design Collection Series, The Locket of Slytherin wand is the perfect addition to any aspiring witch or wizard’s collectables.',
    id: '73',
  },
  {
    name: 'Personalised Slytherin Triwizard Shirt',
    img: './Assets/Images/Goods/slyth_shirt_quid.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Show your loyalty and celebrate your house pride with this bespoke Slytherin Triwizard Shirt. The long-sleeved shirt comes in the traditional house colour of emerald green which is combined with black stripes. The iconic Hogwarts crest is embroidered onto the left-hand side of the shirt which is made up of the symbolic Hogwarts house animals; a lion for Gryffindor, a serpent for Slytherin, a badger for Hufflepuff and an eagle for Ravenclaw.',
    id: '74',
  },
  {
    name: 'Personalised Slytherin House Seeker T-Shirt',
    img: './Assets/Images/Goods/slyth_quid_shirt.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Souvenirs'],
    price: '36',
    description:
      'Celebrate your Hogwarts house loyalty with this bespoke Slytherin House Seeker T-Shirt. The short-sleeved t-shirt comes in the traditional house colour green which is combined with grey stripes along each sleeve. The number 07 is printed in a grey and white design in the centre of the t-shirt alongside the word Slytherin which is printed across the chest in grey. This personalised Slytherin t-shirt is complete with an embroidered grey serpent, the iconic Slytherin house animal.',
    id: '75',
  },
  {
    name: 'Slytherin Knitted Hat',
    img: './Assets/Images/Goods/slyth_hat_1.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '14',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with this Slytherin hat. The knitted hat features the traditional Slytherin colours of emerald green and grey and has been designed with the Slytherin house crest embroidered into the centre which showcases a serpent, the iconic animal of Slytherin. The hat is complete with a green and grey bobble on the top and is a perfect warming gift for Harry Potter fans and proud Slytherin’s.',
    id: '76',
  },
  {
    name: 'Slytherin Mini Gift Trunk',
    img: './Assets/Images/Goods/slyth_set.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Souvenirs', 'Travel'],
    price: '75',
    description:
      'This bespoke Slytherin Mini Gift Trunk celebrates what it means to be a Slytherin with a selection of exclusive souvenirs and unique collectables! Specially designed to resemble what students would take on their travels on the Hogwarts Express, this trunk is the ultimate gifting experience for those sorted into the Slytherin house, or for all Harry Potter fans!',
    id: '77',
  },
  {
    name: 'The Slytherin Mascot Wand',
    img: './Assets/Images/Goods/slyth_wand.png',
    house: 'Slytherin',
    categories: ['Wands', 'Souvenirs'],
    price: '33',
    description:
      'Inspired by the cunning and intelligent mascot of Slytherin House, the Slytherin Mascot wand celebrates the serpent - the beast which Salazar Slytherin was able to speak. For those with great ambition, this design is for leaders who seek to stamp their own mark on the world. The wand is presented in a high-quality box, complete with vellum paper overlay and an information card. Part of the Exclusive Design Collection Series, this unique Slytherin Mascot wand is the perfect addition to add to any aspiring witch or wizard’s collectables.',
    id: '78',
  },
  {
    name: 'Slytherin Hooded Sweatshirt',
    img: './Assets/Images/Goods/slyth_hoodie.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '40',
    description:
      'Add a dash of magic to your wardrobe with this unisex Slytherin hooded sweatshirt. The emerald green hoodie features a grey serpent, the traditional symbol of the Slytherin house, and is complete with the serpent design printed in the lining of the hood.',
    id: '79',
  },
  {
    name: 'Slytherin Fleece Hoodie',
    img: './Assets/Images/Goods/slyth_hoodie_1.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '50',
    description:
      'Refresh your wardrobe with this unisex Slytherin fleece hoodie. The emerald green hoodie features a white serpent embroidered into the right-hand side of the chest. The hoodie is complete with the Slytherin house motto ‘Ambition’, ‘Pride’ and ‘Cunning’ printed in white.',
    id: '80',
  },
  {
    name: 'Slytherin Quidditch Jumper',
    img: './Assets/Images/Goods/slyth_quid.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch'],
    price: '45',
    description:
      'Cheer on your favourite Hogwarts house Quidditch team with this Slytherin Quidditch jumper. Featuring an embroidered Slytherin house crest patch on the left chest in the green and silver colours of the house, this Quidditch sweater is a faithful celebration of the ones seen in the Harry Potter film series. This Slytherin Quidditch jumper is made from 100% super soft acrylic material and is machine washable.',
    id: '81',
  },
  {
    name: 'Slytherin Logo Backpack',
    img: './Assets/Images/Goods/slyth_bag_1.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '36',
    description:
      'Celebrate your Hogwarts house pride with this unique Slytherin backpack. Made from 100% cotton, the backpack features an emerald green design with grey vertical and diagonal stripes across the front. The iconic Slytherin crest is embroidered into the centre of the backpack. The bag has black handles as well as black straps which can be adjusted for a suitable and comfortable fit. The Slytherin backpack is complete with various compartments and pockets, perfect to keep safe or hide any magical trinkets when you’re on-the-go.',
    id: '82',
  },
  {
    name: 'Slytherin Knitted Crest Scarf',
    img: './Assets/Images/Goods/slyth_scarf_1.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '18',
    description:
      'Keep warm in the cold and complete your House outfit with this magical knitted Slytherin scarf featuring the traditional colours of the Slytherin House in emerald green and silvery grey, this scarf is enchanted with leadership and ambition from the heart of the Slytherin House and the perfect accessory to add to your everyday look. Scarf measures 66 inches long and 7 inches in width.',
    id: '83',
  },
  {
    name: 'Slytherin Sock Set (3 Pack)',
    img: './Assets/Images/Goods/slyth_socks.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Souvenirs', 'Travel'],
    price: '12',
    description:
      'Treat your feet with these super soft and comfy Slytherin socks. The socks are available in 3 themed socks with various Slytherin designs in traditional house colours of emerald green and grey.',
    id: '84',
  },
  {
    name: 'Slytherin T-Shirt',
    img: './Assets/Images/Goods/slyth_shirt.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '19',
    description:
      'Possibly the most infamous House of Hogwarts School of Witchcraft and Wizardry, Slytherin students are known to possess the traits of ambition, pride and cunning.',
    id: '85',
  },
  {
    name: 'Slytherin Milk Chocolate Bar',
    img: './Assets/Images/Goods/slyth_choco.png',
    house: 'Slytherin',
    categories: ['Sweets', 'Souvenirs'],
    price: '5',
    description:
      'Get a taste of the Wizarding World with this delicious Slytherin Dark Chocolate Bar. This scrumptious snack is made with mint flavoured dark chocolate and is the perfect sweet treat to make your mouth water.',
    id: '86',
  },
  {
    name: 'Slytherin Lined Backpack',
    img: './Assets/Images/Goods/slyth_bag.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '32',
    description:
      'Add this unique Slytherin backpack to your wardrobe. The bag has been designed in the traditional house colour of green and features the iconic Slytherin crest embroidered in green, grey and black. It features the word ‘Slytherin’ on the embroidered crest, with a silver zip and has a house checkerboard pattern on the inside lining of the backpack. The bag has additional features including a zipper pocket, handle, and adjustable padded straps for suitable and comfortable wear for everyday use. Measures 43x40 cm.',
    id: '87',
  },
  {
    name: 'Slytherin Bobble Hat',
    img: './Assets/Images/Goods/slyth_hat.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '17',
    description:
      'Show off your house pride and keep warm with this Slytherin bobble hat. The hat comes in an emerald green, the traditional colour of Slytherin house and features two white stripes.',
    id: '88',
  },
  {
    name: 'Faux Leather Slytherin Crest Notebook',
    img: './Assets/Images/Goods/slyth_book.png',
    house: 'Slytherin',
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'Any proud Slytherin would be pleased to have this vintage look faux-leather notebook in their home study! This emerald green journal features an impressive metal Slytherin house crest on the front cover, and silver foiled detailing near the border’s edge. Inside you can find a Slytherin Quidditch print on the lining of the cover and distressed parchment style pages that are edged in silver foil. A Slytherin snake can be seen on each page at the bottom right-hand corner. Includes a ribbon in house scarf colours to mark your place.',
    id: '89',
  },
  {
    name: 'Slytherin House Crest Enamel Pin',
    img: './Assets/Images/Goods/slyth_pin.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel', 'Souvenirs'],
    price: '9',
    description:
      'Proudly display which house you belong to with this Slytherin house crest pin! The pin is finely detailed, making it the perfect gift for all Slytherin fans.',
    id: '90',
  },
  {
    name: 'Slytherin Reversible Knit Scarf',
    img: './Assets/Images/Goods/slyth_scarf.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '24',
    description:
      'Get ready to head to the Quidditch match in this bold Slytherin accessory. Perfect for everyday wear, this knitted scarf comes in emerald green and silver - the traditional colours of the Slytherin house. A prominent graphic design of a snake, the house time honoured mascot, is woven just above the long green, black, and silver tassels. On the opposing side, ’SLYTHERIN’ is mirrored along the edge. Makes a great addition to any Slytherin student’s winter wardrobe!',
    id: '91',
  },
  {
    name: 'Slytherin Knitted Mitten Capped Gloves',
    img: './Assets/Images/Goods/slyth_gloves.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Quidditch', 'Travel', 'Souvenirs'],
    price: '12',
    description:
      'Keep warm and cosy on trips between Hogwarts and Hogsmeade with these Slytherin Mitten Capped Gloves. The gloves come in an emerald green design and have grey stripes across the centre, the traditional house colours of Slytherin.',
    id: '92',
  },
  {
    name: 'Slytherin Hoodie',
    img: './Assets/Images/Goods/slyth_hoodie_2.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '45',
    description:
      'Get ready for the Sorting Hat ceremony with this bespoke Slytherin Hoodie. The hoodie features a colour block design in white, light grey and emerald green, the traditional colour of Slytherin. The hoodie is complete with the text ‘Slytherin’ appliqued across the chest.',
    id: '93',
  },
  {
    name: 'Slytherin Moulded Mug',
    img: './Assets/Images/Goods/slyth_cup.png',
    house: 'Slytherin',
    categories: ['Travel', 'Souvenirs'],
    price: '12',
    description:
      'Pour yourself a mugful of your favourite drink in this Slytherin Moulded Mug. The mug is made from ceramic and features a house robe, with a green hood on the reverse, and house tie in emerald green and silver, the traditional colours of the Slytherin house.',
    id: '94',
  },
  {
    name: 'Slytherin Athletic Jacket',
    img: './Assets/Images/Goods/slyth_jacket.png',
    house: 'Slytherin',
    categories: ['Clothes', 'Travel'],
    price: '24',
    description:
      'The long sleeved Slytherin jersey features a stylised crest in foil transfer on the front chest, whilst on the back the house name is emblazoned in Spirit Jersey’s famous puff-text, raised ink across the shoulders, leaving no one in doubt which house you support. ',
    id: '95',
  },
  {
    name: 'Slytherin House Cushion',
    img: './Assets/Images/Goods/slyth_pillow.png',
    house: 'Slytherin',
    categories: ['Toys', 'Travel', 'Souvenirs'],
    price: '26',
    description:
      'Show off your house pride with this bespoke Slytherin house cushion, perfect for any Harry Potter fan to add to their homeware collection. The unique design features velvet applique patches in emerald green and grey, the traditional colours of the Slytherin house. A large serpent, the iconic symbol of Slytherin, has been designed in the centre of the cushion with a grey and black colouring. The reverse features embroidered detailing and the Slytherin house name. The pillow contains a non-removable cushion pad.',
    id: '96',
  },
  {
    name: 'Bertie Bott’s Every Flavour Beans',
    img: './Assets/Images/Goods/beans.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Sweets', 'Travel', 'Souvenirs'],
    price: '10',
    description:
      'Take home these tasty gourmet jelly beans, which come in up to 20 flavours. The flavours range from delicious to disgusting and are presented in the authentic Bertie Bott’s Every Flavour Beans box. Flavours include marshmallows, tutti-frutti, grass, soap, and earwax. They are packaged in a decorated box based on the packaging created for the Harry Potter film series and complete with a bean flavour menu. Beans total approximately 170g. ',
    id: '97',
  },
  {
    name: 'Chocolate Frog with Personalised Wizard Card',
    img: './Assets/Images/Goods/choco_toad.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Sweets', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'Create your very own bespoke personalised wizard card for the ultimate Harry Potter gifting experience. Great for yourself or as the perfect gift for a treasured keepsake, unique to every Hogwarts student. The beloved and best-selling Chocolate Frog with Personalised Wizard Card will be sure to excite both chocolate lovers and collectors alike. Straight off the Hogwarts Express Sweets Trolley, the most famous wizarding confectionery, the Chocolate Frog, is now available to own with a personalised wizard card, designed by you. Packaged in a classic style violet and gold Honeydukes box, along with a delicious edible replica of the milk Chocolate Frog, this confectionery delight contains a collectable witch or wizard card starring you!',
    id: '98',
  },
  {
    name: 'Chocolate Frog Souvenir Tin',
    img: './Assets/Images/Goods/cards.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Sweets', 'Travel', 'Souvenirs'],
    price: '16',
    description:
      'This ornately decorated, pentagonal tin is a keepsake designed to look like the Chocolate Frog box seen throughout the Harry Potter film series. It includes a delicious solid milk Chocolate Frog and 5 lenticular wizard cards, featuring biographies of Hogwarts Headmaster Albus Dumbledore and the Hogwarts House Founders: Godric Gryffindor, Salazar Slytherin, Helga Hufflepuff, and Rowena Ravenclaw.',
    id: '99',
  },
  {
    name: 'Peppermint Toads',
    img: './Assets/Images/Goods/pepper_toads.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Sweets', 'Travel', 'Souvenirs'],
    price: '5',
    description:
      '’Anything off the trolley, dears?’ A long-time favourite from the shelves of Honeydukes Sweet Shop, are these magical dark chocolate Peppermint Toads. Each mouth-watering bite sized toad is infused with a distinctive peppermint flavour that is certain to leave you wanting more. Presented in themed packaging, the delicious Peppermint Toads make the perfect gift, or maybe a treat for yourself, they are sure to be a hit with any Harry Potter fan.',
    id: '100',
  },
  {
    name: 'Bottled Butterbeer',
    img: './Assets/Images/Goods/butt_beer.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Sweets', 'Travel', 'Souvenirs'],
    price: '6',
    description:
      'Experience the fan favourite drink from the Wizarding World in a brand new way at home! Best served chilled and poured straight from the bottle, the delicious soft drink features a new take on the butterscotch fans know and love. The unique blend of top-secret ingredients makes Harry Potter Bottled Butterbeer a must-try for any aspiring witch or wizard! Brewed in the UK, bottled Butterbeer is available to buy in souvenir glass bottles with a collectable label designed exclusively by MinaLima. Bottled Butterbeer is non-alcoholic, vegetarian, vegan and gluten-free. Shipping is available within the UK only. Maximum purchase of three bottles per order.',
    id: '101',
  },
  {
    name: 'Hogwarts School Trunk',
    img: './Assets/Images/Goods/case.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Travel', 'Souvenirs'],
    price: '69',
    description:
      'This Hogwarts School Trunk has been crafted to resemble those used by Hogwarts students for travel on the Hogwarts Express. This decorative collectable Harry Potter trunk is sure to delight any recipient! The Hogwarts Trunk measures 45cm x 30cm x 23cm and features a carry handle and clasp. The Hogwarts school crest is printed on the top of the trunk and features custom initials on the side. Your own Personalised Hogwarts Acceptance Letter is also included. Trunk materials consist of 60% plywood, 20% PU, 10% metal, and 10% glues/lacquers. Please note this trunk is not a toy.',
    id: '102',
  },
  {
    name: 'Personalised Hogwarts Acceptance Letter',
    img: './Assets/Images/Goods/hogwarts_set.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '15',
    description:
      'You can now receive your very own personalised replica of the Hogwarts Acceptance Letter, complete with an exclusive supplies list. Your Hogwarts Acceptance Letter will arrive addressed specifically to the lucky individual, printed in the same shade of green as Harry Potter’s own Acceptance Letter, inside an exclusive Hogwarts Presentation Wallet. The letter features the Hogwarts School of Witchcraft and Wizardry crest and is signed by Professor McGonagall, Professor at Hogwarts and Head of the Gryffindor House.',
    id: '103',
  },
  {
    name: 'Marauder’s Map Interactive Toy',
    img: './Assets/Images/Goods/hogwarts_map.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '50',
    description:
      'You’ll be sure to declare ’I solemnly swear I am up to no good’ with this fold out Marauder’s Map interactive toy. With wand-activated sound effects and appearing footsteps, this toy of the iconic map is the perfect addition to your Harry Potter collection.',
    id: '104',
  },
  {
    name: 'Hogwarts Express Souvenir Ticket',
    img: './Assets/Images/Goods/hogwarts_ticket.png',
    house: ['Gryffindor', 'Hufflepuff', 'Ravenclaw', 'Slytherin'],
    categories: ['Books', 'Travel', 'Souvenirs'],
    price: '5',
    description:
      'Take home your very own replica of the iconic Hogwarts Express Souvenir Ticket. The Hogwarts Express ticket is embellished with gold foil, and is based on the original artwork by MinaLima, the graphic duo, who designed all the original graphic elements for the Harry Potter films. The Hogwarts Express ran between London King’s Cross Station Platform 9¾ and Hogsmeade station about six times a year, and dutifully carried students to and from Hogwarts at the start and end of every term.',
    id: '105',
  },
];
